// Flow types automatically removed

import formStyles from '../styles/FormGeneral.scss';
export const SubText = ({ text }) => {
    return <div className={formStyles.text}>{text}</div>;
};
